import { BigNumber } from '@ethersproject/bignumber';

import { amountToWei, sumRecipientsWei } from './allocation';

import { AllocationErrors, TransferRecipient } from './transferWizard.store';

interface ValidateAllocationsParams {
  recipients: TransferRecipient[];
  totalAmount: string;
  decimals: number;
  availableBalanceWei: BigNumber;
  minAmountWei?: BigNumber;
}

export const validateAllocations = ({
  recipients,
  totalAmount,
  decimals,
  availableBalanceWei,
  minAmountWei,
}: ValidateAllocationsParams): AllocationErrors => {
  const errors: AllocationErrors = { recipients: {} };

  const totalWei = amountToWei(totalAmount, decimals);
  const sumWei = sumRecipientsWei(recipients, decimals);

  const setTotalError = (message: string) => {
    if (!errors.total) {
      errors.total = message;
    }
  };

  if (recipients.length === 0) {
    errors.total = 'Select at least one recipient wallet';
    return errors;
  }

  if (totalWei.isZero()) {
    setTotalError('Enter total amount greater than zero');
  }

  if (!totalWei.eq(sumWei)) {
    setTotalError('Total amount must equal sum of allocations');
  }

  if (totalWei.gt(availableBalanceWei)) {
    setTotalError('Total exceeds available balance');
  }

  recipients.forEach(recipient => {
    const amountWei = amountToWei(recipient.amount, decimals);

    if (amountWei.isZero()) {
      errors.recipients[recipient.walletId] = 'Amount must be greater than zero';
      return;
    }

    if (minAmountWei && amountWei.lt(minAmountWei)) {
      errors.recipients[recipient.walletId] = 'Below minimal transfer amount';
      return;
    }

    errors.recipients[recipient.walletId] = undefined;
  });

  return errors;
};
